import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import cookies from 'vue-cookies'
import store from '../store'
import axios from 'axios'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/UploadHome.vue'),
    beforeEnter: (to, from, next) => {
      let authCode = cookies.get('authCode');
      if (authCode === null && to.name !== 'login') {
        // Thử mà không đặt mật khẩu

        axios.post('/login', {
            authCode: 'unset'
        }).then(res => {
            if (res.status !== 200) {
                throw new Error('Xác thực không thành công!')
            }
            cookies.set('authCode', 'unset', '14d')
            authCode = 'unset'
            next()
        }).catch(err => {
            ElMessage.error('Vui lòng xác thực trước!')
            next({ name: 'login' })
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/AdminDashBoard.vue'),
    beforeEnter: (to, from, next) => {
      // Nhận thông tin đăng nhập từ cửa hàng

      const credentials = store.getters.credentials
      if (credentials === null && to.name !== 'adminLogin') {
        // Thử mà không đặt mật khẩu

        const credentials = btoa('unset:unset')
        fetch ('/api/manage/check', { 
                method: 'GET',
                headers: {
                  'Authorization': 'Basic ' + credentials
                },
                credentials: 'include'
        }).then(res => {
            if (res.status !== 200) {
                throw new Error('Xác thực không thành công!')
            }
            store.commit('setCredentials', credentials)
            next()
        }).catch(err => {
            ElMessage.error('Vui lòng xác thực trước!')
            next({ name: 'adminLogin' })
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/customerConfig',
    name: 'customerConfig',
    component: () => import('../views/CustomerConfig.vue'),
    beforeEnter: (to, from, next) => {
      // Nhận thông tin đăng nhập từ cửa hàng

      const credentials = store.getters.credentials
      if (credentials === null && to.name !== 'adminLogin') {
        // Thử mà không đặt mật khẩu

        const credentials = btoa('unset:unset')
        fetch ('/api/manage/check', { 
                method: 'GET',
                headers: {
                  'Authorization': 'Basic ' + credentials
                },
                credentials: 'include'
        }).then(res => {
            if (res.status !== 200) {
                throw new Error('Xác thực không thành công!')
            }
            store.commit('setCredentials', credentials)
            next()
        }).catch(err => {
            ElMessage.error('Vui lòng xác thực trước!')
            next({ name: 'adminLogin' })
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('../views/AdminLogin.vue'),
  },
  {
    path: '/blockimg',
    name: 'blockimg',
    component: () => import('../views/BlockImage.vue'),
  },
  {
    path: '/whiteliston',
    name: 'whiteliston',
    component: () => import('../views/WhiteListOn.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
